export class Identifiable {
  Id? : string;
}